export enum KeyboardKey {
	Enter = "Enter",
	Escape = "Escape",
	Space = " ",
}
